module.exports = __webpack_public_path__ + "img/YF-JG.8d9f289f.png";